<footer class="page-footer">
    <section *ngIf="showText" [innerHTML]="getHtml()" class="page-footer-text"></section>

    <!-- images -->
    <ul class="footer-images">
        <li><img *ngIf="hasFooterImage()" src="data:image/jpeg;base64,{{ institution.logoFooter }}" class="logo-fdicehl" /></li>
    </ul>
    <!-- /images -->

</footer>